export default __webpack_public_path__ + "static/Idea@1200_2x-f97035448af43cf3b3c98fb545b78bba.png";